import jwtDecode from "jwt-decode";
import http from "./httpService";
import config from '../config.json'

const endPoint = "/api/v1/Auth";

http.setAuthorization(localStorage.getItem("token"));
http.setDefaultHeaders(config.customerId, config.organizationId);

export async function login(username, password) {
    const { data } = await http.post(`${endPoint}/Login`, { username, password });
    localStorage.setItem("token", data.token);
}

export function logout() {
    localStorage.removeItem("token");
}

export function getCurrentUser() {
    try {
        const jwt = localStorage.getItem("token");
        return jwtDecode(jwt)
    } catch (error) {
        return null;
    }
}

export function getUsers(){
    return http.get(endPoint);
}

export function createUser(user){
    return http.post(`${endPoint}/Register`, user);
}

export function changePassword(values){
    return http.put(endPoint, values);
}

export function getRoles(){
    return http.get(`${endPoint}/Roles`);
}

export function setRoles(userId, roles){
    return http.put(`${endPoint}/${userId}/Roles`, roles);
}

export default { 
    login,
    logout,
    getCurrentUser,
    getUsers,
    changePassword,
    getRoles,
    setRoles
};


// WEBPACK FOOTER //
// ./src/services/authService.js